import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "../Contact/contactForm";

const Contact = () => {
  return (
    <div className="contact">
      <div className="row mx-0">
        <div className="col-12 col-xl-6">
          <ContactForm />
        </div>
        <div className="col-6 d-none d-xl-block contactRight">
          <Link to="/" className="btn closeBtn">
            X
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
